import { Component } from "react";
import * as React from "react";
import { SectionHeader } from "../components/visual/SectionHeader";

import { ProductSelector } from "../components/product/ProductSelector";

import { ICustomer } from "../api/models/Customer";
import { ALL_PRODUCTS, Product } from "../api/models/Product";
import { CustomerForm } from "../components/form/CustomerForm";

import { Button } from "src/components/controls/Button";

import { DEFAULT_BACKEND_CONNECTOR } from "src/api/BackendConnector";
import { IOrder } from "src/api/models/Order";

import bgWhiteDirt from "../images/bgWhiteDirt.jpg";
import shells1 from "../images/shells1_bw.jpg"

import { EMAIL } from "src/config/Config";
import { primary } from "src/styles/Colors";
import { OrderModal } from "../components/visual/OrderModal";

interface IOrderViewState {
    error: string;
    errorColor: string;
    products: Array<{
        product: Product,
        amount: number
    }>
    selection: Map<number, number>;
    customer: ICustomer;
    remarks: string;
    isOrdering: boolean;
    retryCount: number;
    modal: {
        isOpen: boolean;
        type: "success" | "error";
        message: string;
    };
}

export class OrderView extends Component<any, IOrderViewState> {
    constructor(props: any) {
        super(props);

        this.state = {
            customer: {} as ICustomer,
            error: "",
            errorColor: "red",
            isOrdering: false,
            modal: {
                isOpen: false,
                message: "",
                type: "success",
            },
            products: ALL_PRODUCTS
                .filter(p => p.soldOut !== true)
                .map(p => {
                    return {
                        amount: 0,
                        product: p,
                    }
                }),
            remarks: null as any,
            retryCount: 0,
            selection: new Map(),
        }

        this.state.products.forEach(p => this.state.selection.set(p.product.id, 0));

        this.handleSelect = this.handleSelect.bind(this);
        this.handleCustomerChange = this.handleCustomerChange.bind(this);
        this.handleRemarksChange = this.handleRemarksChange.bind(this);
        this.handleClickBuy = this.handleClickBuy.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    public render() {
        const selectors = this.state.products.map((p) => (
            <ProductSelector 
                key={p.product.id} 
                product={p.product} 
                amount={this.state.selection.get(p.product.id) as number} 
                onChange={this.handleSelect.bind(this, p.product.id)}
                disabled={this.state.isOrdering}
            />
        ));

        return (
            <div>
                <OrderModal 
                    isOpen={this.state.modal.isOpen} 
                    type={this.state.modal.type} 
                    message={this.state.modal.message} 
                    onClose={this.handleCloseModal}
                />
                <section style={{ paddingTop: "5rem", paddingBottom: "5rem", backgroundSize: "cover", backgroundPosition: "center", backgroundImage: `url(${shells1})` }}>
                    <SectionHeader title="Bestellen" subtitle="Wir freuen uns, dass Sie sich für unsere Produkte interessieren!" titleColor={primary} subtitleColor="white"/>
                </section>
                <section style={{ backgroundImage: `url(${bgWhiteDirt})` }}>
                    <div className="grid-container" style={{ paddingTop: "2rem", paddingBottom: "2rem" }}>
                        <div className="grid-x grid-margin-x">
                            {selectors}
                        </div>
                        <div className="grid-x">
                            <div className="cell medium-8 medium-offset-2 text-center" style={{ paddingTop: "1rem", paddingBottom: "1rem" }}>
                                <h4 style={{ color: "black" }}>Alle Preise zzgl. 4.90 EUR Porto</h4>
                                <hr/>
                            </div>
                        </div>
                    </div>

                </section>
                <section style={{ backgroundColor: "#121215" }}>
                    <div className="grid-container" style={{ paddingTop: "3rem", paddingBottom: "3rem" }}>
                        <div className="grid-x">
                            <div className="cell medium-8 medium-offset-2">
                                <CustomerForm onChange={this.handleCustomerChange} disabled={this.state.isOrdering}/>
                            </div>
                            <div className="cell small-8 medium-offset-2">
                                <label style={{ color: "#fefefe", fontSize: "1rem"}}>
                                    Anmerkungen (optional, maximal 500 Zeichen)
                                    <textarea name="" id="fake-remarks" rows={4} maxLength={500} onChange={this.handleRemarksChange} disabled={this.state.isOrdering}/>
                                </label>
                            </div>
                            <div className="cell medium-offset-2 medium-8">
                                <p style={{ color: this.state.errorColor }}>
                                    { this.state.error }
                                </p>
                            </div>
                            <div className="cell small-3 small-offset-2">
                                <Button 
                                    background={this.state.isOrdering ? "#555" : "#FF8800"} 
                                    color="#050505" 
                                    onClick={this.state.isOrdering ? () => {return} : this.handleClickBuy}>
                                    <b style={{ letterSpacing: ".2rem" }}>
                                        {this.state.isOrdering ? "WIRD GESENDET..." : "JETZT KAUFEN"}
                                    </b>
                                </Button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }

    private handleSelect(productId: number, newAmount: number): void {
        if (newAmount >= 0) {
            const selection = new Map(this.state.selection);
            selection.set(productId, newAmount);
            this.setState({ selection });
        }
    }

    private handleRemarksChange(event: React.ChangeEvent<HTMLTextAreaElement>): void {
        if (event.target !== null) {
            this.setState({ remarks: event.target.value });
        }
    }

    private isEmailValid(email: string): boolean {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    private handleClickBuy(): void {
        if (!this.isEmailValid(this.state.customer.email)) {
            this.setState({ errorColor: "red", error: "Bitte geben Sie eine valide E-Mail-Adresse an!", });
            return;
        }

        // Build order object which will be sent later
        const order: IOrder = { positions: [], customer: this.state.customer };
        this.state.selection.forEach((amount, productId) => {
            if (amount > 0) {
                const product = this.state.products.find(x => x.product.id === productId);
                if (product == null) {
                    throw new Error("Selected product not found!");
                }

                order.positions.push({
                    amount,
                    product: product.product
                })
            }
        })

        order.remarks = this.state.remarks;

        if (order.positions.length !== 0) {
            this.setState({ isOrdering: true, error: "" });
            
            DEFAULT_BACKEND_CONNECTOR.sendOrder(order)
                .then(response => {
                    if (response.status < 200 || response.status >= 300) {
                        throw new Error("Received unexpected status code " + response.status + "!");
                    } else {
                        // Clear selection on success
                        const clearedSelection = new Map(this.state.selection);
                        clearedSelection.forEach((v, k) => clearedSelection.set(k, 0));

                        this.setState({ 
                            isOrdering: false,
                            modal: {
                                isOpen: true,
                                message: "Vielen Dank für Ihre Bestellung! Wir haben Ihre Anfrage erhalten und werden uns in Kürze bei Ihnen melden.",
                                type: "success",
                            },
                            selection: clearedSelection,
                        });
                    }
                })
                .catch(err => {
                    const newRetryCount = this.state.retryCount + 1;
                    let errorMessage = "Es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut.";
                    
                    if (newRetryCount >= 3) {
                        errorMessage = "Leider konnte Ihre Bestellung auch nach mehreren Versuchen nicht gesendet werden. Bitte kontaktieren Sie uns per E-Mail unter " + EMAIL + " oder telefonisch. Vielen Dank!";
                    }

                    this.setState({ 
                        isOrdering: false, 
                        modal: {
                            isOpen: true,
                            message: errorMessage,
                            type: "error",
                        },
                        retryCount: newRetryCount,
                    });
                })
        } else {
            this.setState({ errorColor: "red", error: "Sie müssen wenigstens einen Artikel auswählen!", })
        }
    }

    private handleCloseModal() {
        const isSuccess = this.state.modal.type === "success";
        this.setState({ 
            modal: { ...this.state.modal, isOpen: false } 
        }, () => {
            if (isSuccess) {
                // Redirect to home on success
                if (this.props.history) {
                    this.props.history.push("/home");
                } else {
                    window.location.href = "/home";
                }
            }
        });
    }

    // tslint:disable-next-line:no-empty
    private handleCustomerChange(newCustomer: ICustomer) {
        this.setState({ customer: newCustomer })
    }
}



// WEBPACK FOOTER //
// ./src/views/OrderView.tsx